import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type LayersIconProps = IconProps;

export const LayersIcon: FC<LayersIconProps> = ({ iconColor = '#344054', className, ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8305 2.17998C12.5699 2.06113 12.2868 1.99963 12.0005 1.99963C11.7141 1.99963 11.431 2.06113 11.1705 2.17998L2.60045 6.07998C2.423 6.15823 2.27213 6.28638 2.16621 6.44884C2.0603 6.6113 2.00391 6.80105 2.00391 6.99498C2.00391 7.18892 2.0603 7.37867 2.16621 7.54113C2.27213 7.70359 2.423 7.83174 2.60045 7.90998L11.1805 11.82C11.441 11.9388 11.7241 12.0003 12.0105 12.0003C12.2968 12.0003 12.5799 11.9388 12.8405 11.82L21.4205 7.91998C21.5979 7.84174 21.7488 7.71358 21.8547 7.55113C21.9606 7.38867 22.017 7.19892 22.017 7.00498C22.017 6.81105 21.9606 6.6213 21.8547 6.45884C21.7488 6.29638 21.5979 6.16823 21.4205 6.08998L12.8305 2.17998Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M1.99951 12C1.99904 12.1913 2.05343 12.3787 2.15623 12.5399C2.25903 12.7012 2.40593 12.8297 2.57951 12.91L11.1795 16.82C11.4387 16.9374 11.72 16.9981 12.0045 16.9981C12.2891 16.9981 12.5703 16.9374 12.8295 16.82L21.4095 12.92C21.5865 12.8404 21.7366 12.7111 21.8413 12.5477C21.9461 12.3844 22.001 12.1941 21.9995 12"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M1.99951 17C1.99904 17.1913 2.05343 17.3786 2.15623 17.5399C2.25903 17.7012 2.40593 17.8297 2.57951 17.91L11.1795 21.82C11.4387 21.9374 11.72 21.9981 12.0045 21.9981C12.2891 21.9981 12.5703 21.9374 12.8295 21.82L21.4095 17.92C21.5865 17.8404 21.7366 17.7111 21.8413 17.5477C21.9461 17.3844 22.001 17.1941 21.9995 17"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
